import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="space-y-4">
            <div className="text-3xl font-bold hero-title">
              <span
                style={{
                  background: 'linear-gradient(135deg, #ffffff 0%, #c9a961 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                SUKI
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Detailing automobile haut de gamme à Montmagny et Courbevoie. Excellence, précision et passion pour votre véhicule.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/suki_paris?igsh=MWw0MnBtYW94ZzY3Mg%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#c9a961]/20 flex items-center justify-center hover:bg-[#c9a961] transition-all duration-300"
                data-testid="footer-instagram-link"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://www.facebook.com/share/17XwxddMzm/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#c9a961]/20 flex items-center justify-center hover:bg-[#c9a961] transition-all duration-300"
                data-testid="footer-facebook-link"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://www.tiktok.com/@_suki_paris?_t=ZN-90zF8hGaV2U&_r=1"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#c9a961]/20 flex items-center justify-center hover:bg-[#c9a961] transition-all duration-300"
                data-testid="footer-tiktok-link"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 section-title">Navigation</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#c9a961] transition-colors text-sm">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-[#c9a961] transition-colors text-sm">
                  Nos Services
                </Link>
              </li>
              <li>
                <Link to="/reservation" className="text-gray-400 hover:text-[#c9a961] transition-colors text-sm">
                  Réservation
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-[#c9a961] transition-colors text-sm">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-gray-400 hover:text-[#c9a961] transition-colors text-sm">
                  Avis Clients
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#c9a961] transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6 section-title">Nos Services</h3>
            <ul className="space-y-3">
              <li className="text-gray-400 text-sm">Polissage & Correction</li>
              <li className="text-gray-400 text-sm">Protection Céramique</li>
              <li className="text-gray-400 text-sm">Lavage Détaillé</li>
              <li className="text-gray-400 text-sm">Décontamination</li>
              <li className="text-gray-400 text-sm">Protection Nano</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6 section-title">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#c9a961] mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">Montmagny et Courbevoie, France</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-[#c9a961] flex-shrink-0" />
                <a href="tel:0650470940" className="text-gray-400 hover:text-[#c9a961] transition-colors text-sm">
                  06 50 47 09 40
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-[#c9a961] flex-shrink-0" />
                <a
                  href="mailto:contact.sukiauto@gmail.com"
                  className="text-gray-400 hover:text-[#c9a961] transition-colors text-sm break-all"
                >
                  contact.sukiauto@gmail.com
                </a>
              </li>
            </ul>
            <div className="mt-6">
              <p className="text-gray-400 text-xs mb-2">Horaires d'ouverture</p>
              <p className="text-gray-500 text-xs">Lun - Sam: 9h00 - 19h00</p>
              <p className="text-gray-500 text-xs">Dimanche: Sur rendez-vous</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} SUKI Montmagny. Tous droits réservés.
          </p>
          <div className="flex space-x-6">
            <Link to="#" className="text-gray-500 hover:text-[#c9a961] transition-colors text-xs">
              Mentions légales
            </Link>
            <Link to="#" className="text-gray-500 hover:text-[#c9a961] transition-colors text-xs">
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
